import { EnvironmentInterface } from '../app/core/models/environment.interface';

export const environment: EnvironmentInterface = {
    production: false,
    providers: [],
    macBackendUrl: ''
};
